import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RouteType } from 'src/shared/constants';
import { ConfigClient } from 'src/shared/services/api.service';

@Component({
  selector: 'cert-unhandled-error',
  templateUrl: './unhandled-error.component.html',
  styles: ``,
  standalone: false,
})
export class UnhandledErrorComponent {
  @Input() traceId!: string;
  @Input() errorId!: string;
  @Input() currentRouteType!: RouteType;

  RouteType = RouteType;

  constructor(
    private readonly activeModal: NgbActiveModal,
    private readonly configClient: ConfigClient,
  ) {}

  onReportError() {
    this.configClient
      .reportError({
        site: 'Certification',
        traceId: this.traceId,
        errorId: this.errorId,
      })
      .subscribe(() => {
        this.activeModal.close(true);
      });
  }

  onCancel() {
    this.activeModal.close(false);
  }
}
